import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import type { SaveSonarQubeConnectionRequest, TestSonarQubeConnectionRequest } from '@/types'
import { CONNECTOR_LABELS } from './connectorConstants'
import { SonarQubeConnectionForm } from './SonarQubeConnectionForm'

interface SonarQubeEnableDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  onTest: (data: TestSonarQubeConnectionRequest) => Promise<void>
  onSave: (data: SaveSonarQubeConnectionRequest) => Promise<void>
  isTesting: boolean
  isSaving: boolean
  tokenInlineError?: string | null
  saveError?: string | null
}

export function SonarQubeEnableDialog({
  open,
  onOpenChange,
  onTest,
  onSave,
  isTesting,
  isSaving,
  tokenInlineError,
  saveError,
}: SonarQubeEnableDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[640px]">
        <DialogHeader>
          <DialogTitle>Connect {CONNECTOR_LABELS.SonarQube}</DialogTitle>
        </DialogHeader>
        <SonarQubeConnectionForm
          connection={undefined}
          open={open}
          onTest={onTest}
          onSave={onSave}
          onCancel={() => onOpenChange(false)}
          isTesting={isTesting}
          isSaving={isSaving}
          submitLabel="Connect"
          submitSavingLabel="Connecting..."
          tokenInlineError={tokenInlineError}
          saveError={saveError}
        />
      </DialogContent>
    </Dialog>
  )
}
